<template>
  <div class="d-flex flex-column align-start justify-start">
    <div class="d-flex align-center justify-start">
      <v-skeleton-loader
        v-if="showLogo"
        type="card-avatar"
        width="48px"
        height="48px"
        class="mr-7"
      />
      <v-skeleton-loader
        type="heading"
        class="home-header-heading"
        width="270px"
      />
    </div>
    <v-skeleton-loader
      type="text"
      class="mt-4 home-header-text"
      width="100%"
      height="19px"
    />
    <v-skeleton-loader
      type="text"
      class="mt-3 home-header-text"
      width="100%"
      height="19px"
    />
    <v-skeleton-loader
      v-if="isAdminOn"
      type="text"
      class="mt-3 home-header-text"
      width="100%"
      height="19px"
    />
    <v-skeleton-loader
      v-if="isAdminOn"
      type="text"
      class="mt-3 home-header-text"
      width="100%"
      height="19px"
    />
  </div>
</template>

<script>
export default {
  name: 'HomeHeaderSkeletonLoader',
  props: {
    isAdminOn: {
      type: Boolean,
      default: false,
    },
    showLogo: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
:deep(.v-skeleton-loader__bone) {
  width: 100%;
}

:deep(.v-skeleton-loader__card-avatar), :deep(.v-skeleton-loader__image) {
  height: 48px;
}

:deep(.v-skeleton-loader__heading), :deep(.v-skeleton-loader__text) {
  margin: 0;
}

.home-header-heading:deep(.v-skeleton-loader__bone) {
  height: 42px;
}

.home-header-text:deep(.v-skeleton-loader__bone) {
  height: 19px;
}
</style>
